module.exports = __webpack_public_path__ + "img/commerce4.1918394c.png";